import { ProductSupplier } from 'types/product-suppliers';

export const B2B: ProductSupplier = {
  id: 0,
  name: 'B2B',
};
const B2C = 'B2C';

export const getB2CSupplier = (productSuppliers: ProductSupplier[]): ProductSupplier => {
  const b2CSupplier = productSuppliers.find(isB2C);
  if (b2CSupplier == null) {
    throw new Error('No B2C Supplier found');
  }
  return b2CSupplier;
};

export const SOURCING_CODE = 'SOURC';

export const isB2C = (supplier: ProductSupplier | null): boolean => {
  return supplier != null && supplier.name === B2C;
};
